import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { View } from "@faire/retailer-visitor-shared/components/AppSignIn/components/View";
import { AppleLoginButton } from "@faire/retailer-visitor-shared/components/SocialSignOnButtons/AppleLoginButton";
import { GoogleLoginButtonV2 } from "@faire/retailer-visitor-shared/components/SocialSignOnButtons/GoogleLoginButtonV2";
import { OktaLoginButton } from "@faire/retailer-visitor-shared/components/SocialSignOnButtons/OktaLoginButton";
import { Spacer } from "@faire/web--source/slate/spacing";
import { SocialSignOnProvider } from "@faire/web-api--source/indigofair/data/SocialSignOnProvider";
import React from "react";
export var SocialLoginButton = function(param) {
    var provider = param.provider, onFinish = param.onFinish, onLogin = param.onLogin, onConfirmPassword = param.onConfirmPassword, sourceId = param.sourceId;
    var onSignIn = function(user) {
        onLogin(user);
        onFinish({
            nextView: View.LOADING,
            user: user
        });
    };
    //TODO: ADD NEW MFA UI FOR SSO
    var onSelectMFA = function(mfaOptions) {
        onFinish({
            nextView: View.SELECT_MFA_OPTION,
            mfaOptions: mfaOptions
        });
    };
    var onMFA = function(mfaDescription, mfaTitle) {
        onFinish({
            nextView: View.ENTER_MFA,
            mfaTitle: mfaTitle,
            mfaDescription: mfaDescription
        });
    };
    switch(provider){
        case SocialSignOnProvider.GOOGLE:
            return /*#__PURE__*/ _jsxs(_Fragment, {
                children: [
                    /*#__PURE__*/ _jsx(Spacer, {
                        height: "3x"
                    }),
                    /*#__PURE__*/ _jsx(GoogleLoginButtonV2, {
                        onSignIn: onSignIn,
                        onMFA: onMFA,
                        onSelectMFA: onSelectMFA,
                        onConfirmPassword: onConfirmPassword,
                        sourceId: sourceId,
                        isOnSignIn: true
                    })
                ]
            });
        case SocialSignOnProvider.APPLE:
            return /*#__PURE__*/ _jsxs(_Fragment, {
                children: [
                    /*#__PURE__*/ _jsx(Spacer, {
                        height: "3x"
                    }),
                    /*#__PURE__*/ _jsx(AppleLoginButton, {
                        onSignIn: onSignIn,
                        onMFA: onMFA,
                        onSelectMFA: onSelectMFA,
                        onConfirmPassword: onConfirmPassword,
                        sourceId: sourceId,
                        isOnSignIn: true
                    })
                ]
            });
        case SocialSignOnProvider.OKTA:
            return /*#__PURE__*/ _jsxs(_Fragment, {
                children: [
                    /*#__PURE__*/ _jsx(Spacer, {
                        height: "3x"
                    }),
                    /*#__PURE__*/ _jsx(OktaLoginButton, {
                        onSignIn: onSignIn,
                        onMFA: onMFA,
                        onSelectMFA: onSelectMFA,
                        onConfirmPassword: onConfirmPassword,
                        sourceId: sourceId,
                        isOnSignIn: true
                    })
                ]
            });
        default:
            return null;
    }
};
